// ============================================================
// UTILITIES
// ============================================================

let _uid = 0;

export function nextId(): number {
  return ++_uid;
}

export function resetId(): void {
  _uid = 0;
}

export function nextUnitId(): string {
  return 'U' + (++_uid);
}

/** Random integer in [a, b] inclusive */
export function ri(a: number, b: number): number {
  return Math.floor(Math.random() * (b - a + 1)) + a;
}

/** Manhattan distance */
export function md(a: { x: number; y: number }, b: { x: number; y: number }): number {
  return Math.abs(a.x - b.x) + Math.abs(a.y - b.y);
}

/** Chebyshev distance (square range — includes diagonals) */
export function cd(a: { x: number; y: number }, b: { x: number; y: number }): number {
  return Math.max(Math.abs(a.x - b.x), Math.abs(a.y - b.y));
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * Math.min(1, Math.max(0, t));
}

export function clamp(v: number, lo: number, hi: number): number {
  return Math.max(lo, Math.min(hi, v));
}
